import { React, useState, useEffect } from "react";

const PopUpCRResults = ({ resultsData, catMid, marketType }) => {
    const resultData = resultsData;

    const formatMarketStartTime = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return "";
        return date.toLocaleString("en-US", {
            month: "numeric",
            day: "numeric",
            year: "numeric",
            hour: "numeric",
            minute: "2-digit",
            second: "2-digit",
            hour12: true
        });
    };

    useEffect(() => {
        console.log("Market Type:", marketType);
        console.log("Results Data:", resultsData);
    }, [resultsData, marketType]);

    const dataObj = resultsData;

    return (
        <div>

            <div id="ResultsData">
                <div class="left-content site_family">

                    <div id="chicken-road" style={{ display: marketType == 60 ? "" : "none" }} >
                        <div class="left-content">
                            <div class="card">
                                <div class="card-header">
                                    Market Start Time = {formatMarketStartTime(dataObj.evt_od)}
                                </div>
                                <div class="card-body">
                                    <div style={{ textAlign: "-webkit-center" }}>
                                        <table style={{ width: "100%" }}>
                                            <tbody>
                                                <tr>
                                                    <td style={{ paddingRight: "10px" }}>
                                                        <div class="cards">
                                                            <div class="cardsText"> </div>

                                                            <div class="font-familyAVE absoluteAve flexAve flex-colAve items-center drop-shadow-mdAve font-blackAve text-strokeAve tracking-wideAve w-100 text-rose-600Ave AnimateOdds">
                                                                <div
                                                                    class="flexAve items-endAve gap-1Ave w-42 text-strokeblackAve"
                                                                    style={{ fontSize: "40px" }}
                                                                >
                                                                    {resultData?.is_loss
                                                                        ? `CRASHED at ${resultData?.result}`
                                                                        : `CASHOUT at ${resultData?.result}`}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <style>{`

        body{
          font-size:13px;
        }
        .player-item {
            margin-bottom: 16px;
            display: block;
            margin-right: 0;
            z-index: 0;
        }

          .player-card {
            border-radius: 12px;
            border: 1px solid rgb(14 99 8 / 25%);
          }

        .card{
            border-radius: 12px;
            padding:8px;
            margin:auto;
            border: 1px solid rgb(14 99 8 / 25%);
        }

        .BFBCardFanViewab {
            flex-wrap: wrap;
        }


        .RSMImageView2ab {
            padding: 3px;
            display:contents;
        }

        .BFBCardHandViewDealerab {
            transform: translate3d(0,0,0);
            width: 100%;
            height: auto;
            text-align: center;
        }

        .diceofresults {
            width: 75px;
            height: 75px;
            border: 1px solid black;
            border-radius: 15px;
            margin: 0px 10px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 45px;
            box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
            color: red;
        }
        .TdResults {
            padding: 0;
            vertical-align: top;
            flex: 1 1 auto;
            box-sizing: border-box;
            max-width: calc(33.33% - 20px);
            min-width: 120px;
            background: linear-gradient(#535353, #0f0f0f);
            border-radius: 10px;
            margin: 1px;
        }
        .bgwinner {
            border-radius: 10px;
            background-color: #cf8d2e !important;
        }
        .bgLoser {
            border-radius: 10px;
            background-color: #cf3f3f !important;
        }
        .TdResultsWin {
            background: #008000 !important;
        }
        .cards {
            border-width: 1px;
            border-style: solid;
            padding: 5px;
            background-color: #f8f8f8;
            border-color: #dbdbdb;
        }
        .font-blackAve {
          font-weight: 900;
      }
      .text-strokeAve {
        text-shadow: -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
    }
    .tracking-wideAve {
      letter-spacing: .025em;
  }
  .text-rose-600Ave {
    color: rgb(225, 29, 72, 1) !important;
}
.flex-colAve {
  flex-direction: column;
}
.items-center {
  align-items: center;
}
.text-strokeblackAve {
  text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000;
}
.gap-1Ave {
  gap: .25rem;
}
.items-endAve {
  align-items: flex-end;
}
.flexAve {
  display: flex;
}

.dream-runner .runner-disabled {
    margin-left: auto;
}

.sicbo-result-row{
    text-align:center;
    margin-bottom:18px;
}

.sicbo-market{
    font-size:20px;
    font-weight:700;
    color:#222;
    line-height:1.2;
}

.sicbo-status{
    font-size:14px;
    font-weight:600;
    margin-top:3px;
    text-transform:uppercase;
}

.sicbo-winner{
    color:#28a745;
}

.sicbo-loser{
    color:#666;
}
    #race20 .player-card,
    #race17 .player-card,
    #casino-war .player-card,
    #center-card .player-card, 
    #trio .player-card, 
    #trap .player-card,
    #one-card .player-card,
    #head-tail .player-card,
    #high-card .player-card,
    #dus-ka-dum .player-card,
    #lottery-virtual .player-card,
    #one-meter-card .player-card,
    #dragon-tiger .player-card,
    #andar-bahar .player-card,
    #bollywood .player-card,
    #queen-race .player-card,
    #super-over .player-card {
    background: none;
    padding: 0 !important;
}
      `}</style>
        </div>
    );
};

export default PopUpCRResults;